export const sectionTitle = {
  fontSize: 42,
  lineHeight: "3rem",
  fontWeight: 700,
  color: "#18181B",
};

export const sectionContent1 = {
  fontSize: 18,
  lineHeight: "1.875rem",
  fontWeight: 600,
  margin: "1.625rem 0",
  color: "#12141D",
};
